<script type="text/javascript">
	import {onMount} from "svelte"
	import { createEventDispatcher } from 'svelte';
	import {get, writable} from "svelte/store"
	import moment from "moment";

	import API from "../../API/API"
	import AdminStore from "./Store"
	import FeaturesOverrides from "./FeaturesOverrides.svelte";
	import ModelType from "../../Models/ModelType"

	import Form from './Form.svelte';
	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Select, {Option} from '@smui/select';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import Icon from "@smui/textfield/icon/index";
	import SpinnerButton from "./SpinnerButton.svelte";

	import ValidationHelper from "../../Helpers/ValidationHelper";
	import { formatUnixTimestamp } from "../../Helpers/Misc/timeHelper";

	export let user = null; // User Model

	const dispatch = createEventDispatcher(); // submit | reset | delete

	const Loading = {
		NONE: -1,
		ENABLING_USER: 0,
		DISABLING_USER: 0,
		RESETTING_PASSWORD: 1,
		ADDING_USER: 2,
		SAVING_USER: 3,
		DELETING_USER: 4
	};

	let createEditable = (user) => {
		return {
			isNew: user.isNew(),
			username: user.username,
			displayname: user.displayName,
			email: user.email,
			company_name: user.companyName,
			feature_overrides: user.featureOverrides
			// features: JSON.parse(JSON.stringify(user.features))
		};
	};
	let editable = createEditable(user);

	let form = null;
	let loading = writable(Loading.NONE);

	let style = "width:100%;margin-top:10px;";
	$: if (form) form.setReadOnly($loading != Loading.NONE);

	let companies = AdminStore.cms.companies;

	let onEnable = () => { setEnabled(true); }
	let onDisable = () => { setEnabled(false); }
	let onReset = () => {
		editable = createEditable(user);
		console.log("init/reset editable", editable);
		dispatch('reset');
	}

	let setEnabled = (enabled) => {
		$loading = (enabled)?Loading.ENABLING_USER:Loading.DISABLING_USER;
		API.put("admin/users/" + user.id + "/set-enabled", {
				enabled: enabled
			}).then((response) =>{
				console.log("response", response);
				user.setData(response);
				onReset();
				dispatch('submit', {user});
				form.snackbar.start("User "+((enabled)?"enabled":"disabled")+" successfully.", "success");
			}).catch(()=>{
				form.snackbar.start("User "+((enabled)?"enable":"disable")+" failed.", "error")
			}).finally(() => {
				$loading = Loading.NONE;
			});
	}
	let onSubmit = () => {

		const usernameErrs = ValidationHelper.validateUsername(editable.username);
		const emailAddressErrs = ValidationHelper.validateEmailAddress(editable.email);
		if (usernameErrs.length > 0) {
			form.snackbar.start(usernameErrs[0], "error");
			return;
		}
		if (emailAddressErrs.length > 0) {
			form.snackbar.start(emailAddressErrs[0], "error");
			return;
		}
		let company = AdminStore.helpers.getCompanyByName(editable.company_name);
		if (company === null) {
			form.snackbar.start("Invalid company.", "error");
			return;
		}

		let data;

		if (user.isNew()){
			data = {
				username: editable.username,
				displayname: editable.displayname,
				email: editable.email,
				company_id: company.id,
				features: {}
			}
		}
		else {
			data = {
				email: editable.email,
				displayname: editable.displayname,
				company_id: company.id,
				features: editable.feature_overrides
			}
		}
		console.log('submit data', data);

		// We only want to send the info that has changed... I think...
		let n = user.isNew();
		let url = n ? "admin/users/create" : "admin/users/" + user.id;
		$loading = Loading.SAVING_USER;
		API.put(url, data)
			.then((response) =>{
				console.log("response", response);
				if (user.isNew()) {
					AdminStore.actions.addUser(user);
				}
				user.setData(response);
				onReset();
				form.snackbar.start("User " + (n ? "created" : "updated") + " successfully.", "success");
				dispatch('submit', {user});
			}).catch((error)=>{
				console.error(error.data.title, error.data.detail);
				form.snackbar.start("User " + (n ? "creation" : "update") + " failed.", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	};
	let onDelete = () => {
		//form.snackbar.start("Not yet implemented", "error");
		AdminStore.cms.confirmDialog.onConfirm = () => {
			$loading = Loading.DELETING_USER;
			API.delete("admin/users/" + user.id)
				.then((response)=>{
					console.log(response);
					form.snackbar.start("User deleted successfully.", "success");
					AdminStore.actions.deleteUser(user);
					dispatch('delete');
				})
				.catch((error)=>{
					console.error(error.data.title, error.data.detail);
					form.snackbar.start("User deletion failed.", "error");
				})
				.finally(()=>{
					$loading = Loading.NONE;
					AdminStore.cms.confirmDialog.visible.set(false);
				});
		}
		AdminStore.cms.confirmDialog.visible.set(true);
	}
	let onResetPassword = () => {
		//form.snackbar.start("Not yet implemented", "error");
		$loading = Loading.RESETTING_PASSWORD;
		API.put("admin/users/" + user.id + "/reset-password")
			.then((response) =>{
				console.log("response", response);
				user.setData(response);
				onReset();

				if (typeof response['temporary_password'] !== "undefined") {
					form.snackbar.start("User password reset to: " + response['temporary_password'] + ".", "success");
				}
				else {
					form.snackbar.start("User password reset successfully.", "success");
				}

				dispatch('submit', {user});

			}).catch((e)=>{
				console.error('err', e);
				form.snackbar.start("User reset password failed.", "error")
			}).finally(() => {
				$loading = Loading.NONE;
			});
	};

	let userActivity = writable([]);
	let dateFormat = "MMMM Do YYYY, hh:mm:ssa [(UTC)]";

	onMount(()=>{
		onReset();
		if (!user.isNew()) {
			API.get("admin/analytics/user-activity?id=" + user.id)
				.then((result)=>{
					console.log(result);
					$userActivity = result;
				})
				.catch((e)=>{
					console.error(e);
				})
		}
	});
</script>

<Form bind:this={form} id='admin-user-form'>
	{#if user.isNew()}
		<h2>New User</h2>
	{:else}
		<h2>Existing User</h2>
	{/if}

	<DataTable table$aria-label="User" style={style}>
		<Head style="display: none">
			<Row>
				<Cell></Cell>
				<Cell></Cell>
			</Row>
		</Head>
		<Body>
			{#if editable.isNew}
				<Row>
					<Cell>Username</Cell>
					<Cell>
						<Textfield dense variant="outlined" bind:value={editable.username} style="width:100%" />
					</Cell>
				</Row>
			{:else}
				<Row>
					<Cell>Username</Cell>
					<Cell>{editable.username}</Cell>
				</Row>
			{/if}
			<!-- <Row>
				<Cell>Data</Cell>
				<Cell>{JSON.stringify(user.data)} {user.isNew()}</Cell>
			</Row> -->
			<Row>
				<Cell>Display Name / Full Real Name</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.displayname} style="width:100%" />
				</Cell>
			</Row>
			<Row>
				<Cell>Email</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.email} style="width:100%" />
				</Cell>
			</Row>
			<Row>
				<Cell>Company</Cell>
				<Cell>
					<select class='default' bind:value={editable.company_name} style="width:100%;">
						{#if user.isNew()}
							<option value={""} selected={editable.company_name === "None"}>Please select</option>
						{/if}
						{#each $companies as company}
							<option value={company.name} selected={editable.company_name === company.name}>{company.name}</option>
						{/each}
					</select>
				</Cell>
			</Row>
			{#if !user.isNew()}
				<!-- <Row>
					<Cell>Email Verified:</Cell>
					<Cell>{user.email_verified}</Cell>
				</Row> -->
				<Row>
					<Cell>Enabled</Cell>
					<Cell>{user.enabled}</Cell>
				</Row>
				<Row>
					<Cell>Account Status</Cell>
					<Cell>{user.status}</Cell>
				</Row>
				<!-- <Row>
					<Cell>SMS MFA Status</Cell>
					<Cell>...</Cell>
				</Row> -->
				<Row>
					<Cell>Last Modified</Cell>
					<Cell>{formatUnixTimestamp(user.modifiedTimestamp)}</Cell>
				</Row>
				<Row>
					<Cell>Created</Cell>
					<Cell>{formatUnixTimestamp(user.createdTimestamp)}</Cell>
				</Row>
				<Row>
					<Cell>Cognito ID</Cell>
					<Cell>{user.cognitoId}</Cell>
				</Row>
			{/if}
		</Body>
	</DataTable>

	{#if !user.isNew()}
		<FeaturesOverrides editable={editable} model={user} modelType={ModelType.USER} />
	{/if}


	<h2 style={style+";margin-bottom:0px;"}>Actions</h2>
	{#if $loading == Loading.SAVING_USER}
		<SpinnerButton style={style} />
	{:else}
		<Button on:click={onSubmit} color="primary" variant="unelevated" style={"width:100%;"}><Label>{((user.isNew())?"Add User":"Update User")}</Label></Button>
	{/if}

	<Button on:click={onReset} color="primary" class="bg-info" variant="unelevated" style={style}><Label>Reset</Label></Button>

	{#if !user.isNew()}
		<hr style={style}/>
		<!-- <h2 style={style}>Actions</h2> -->

		{#if $loading == Loading.ENABLING_USER || $loading == Loading.DISABLING_USER}
			<SpinnerButton style={style}/>
		{:else}
			{#if user.enabled}
				<Button color="secondary" variant="unelevated" style={style} on:click={onDisable}><Label>Disable User</Label></Button>
			{:else}
				<Button color="secondary" variant="unelevated" style={style} on:click={onEnable}><Label>Enable User</Label></Button>
				<Button color="secondary" variant="unelevated" class="bg-error" on:click={onDelete} style={style}><Label>Delete User</Label></Button>
			{/if}
		{/if}

		{#if $loading == Loading.RESETTING_PASSWORD}
			<SpinnerButton style={style}/>
		{:else}
			<Button color="secondary" variant="unelevated" style={style} on:click={onResetPassword}><Label>Reset Password</Label></Button>
		{/if}
	{/if}

	{#if !user.isNew()}
		<hr style={style}/>

		<div style='padding:20px;'>
			<h2 style={style+";margin-bottom:0px;"}>Activity</h2>
			<table class='svelte-table' style='width:100%;'>
				<tr>
					<th width=20%>Time</th>
					<th width=10%>Category</th>
					<th width=10%>Event</th>
					<th>Data</th>
				</tr>
				{#if $userActivity.length === 0}
					<tr>
						<td colspan='4'>No activity</td>
					</tr>
				{/if}
				{#each $userActivity as item}
					<tr>
						<td>{moment(item.timestamp*1000).format(dateFormat)}</td>
						<td>{item.category}</td>
						<td>{item.event}</td>
						<td>{item.data_json}</td>
					</tr>	
				{/each}
			</table>
		</div>
	{/if}
</Form>
